<!--
 * @Author: chenmengnan chenmengnan@piesat.cn
 * @Date: 2025-03-19 11:17:18
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-24 11:25:31
 * @FilePath: \web\src\components\Portal\Market\DeepSeekResult.vue
 * @Description: 
 * 
-->
<template>
  <section class="deepseek-result">
    <ul class="scroll-list scroll-container" ref="scrollContainer" @scroll="handleScroll">
      <li v-for="(item, index) in list" :key="item.id">
        <section v-if="item.type === 'problem'" class="problem">
          <img :src="img_copy" alt="复制" title="复制" @click="copyText(item.content, $event)">
          <!-- <img src="" alt=""> -->
          <span>{{ item.content }}</span>
        </section>
        <section v-else class="answer">
          <img :src="img_deepseek" alt="">
          <section class="answer-content">
            <span class="no-think" v-if="!item.deep && item.loading"><sync-outlined spin /></span>
            <span class="think" v-if="item.deep && item.loading">思考中...</span>
            <span class="think" :class="item.show ? 'down' : 'up'" v-else-if="item.deep && !item.loading"
              @click="changeThinkConten(item, index)">已深度思考（用时{{
                ((item.eTime -
                  item.sTime) / 1000).toFixed(1) }}） <i></i></span>
            <template v-for="ele in item.content" :key="ele.index">
              <span class="think-conten" v-if="item.deep && item.show">{{ ele.message.reasoning_content }}</span>
              <span class="result-conten" v-html="ele.message.contentHtml"></span>
              <span class="AI-warn">本回答由 AI生成，内容仅供参考，请仔细甄别。</span>
              <section class="answer-btns">
                <img :src="img_copy" alt="复制" title="复制" @click="copyText(ele.message.content, $event)">
                <img :src="img_refresh" alt="刷新" title="刷新" @click="refreshText(index)">
              </section>
            </template>

          </section>
        </section>
      </li>
    </ul>
    <section class="input">
      <a-textarea v-model:value="searchValue" placeholder="给 deepseek 发送消息" :rows="3" />
      <span class="send-btn" :class="searchValue.length === 0 && 'no-message'" v-if="!loading"
        @click="searchValue.length > 0 ? searchDeepSeek() : ''"></span>
      <span class="loading" v-else><i></i></span>
    </section>
  </section>
</template>

<script setup>
import { onBeforeMount, ref, reactive, watch, } from 'vue';
import config from '@/config/config';
import { getDeepSeekApi } from "@/api/utils/utilsApi";
import { getDeepSeekCount, setDeepSeekCount } from "@/api/Portal/marketApi"
import { marked } from 'marked';
import handleCopy from '@/utils/clipboard';
import DOMPurify from 'dompurify';
import img_copy from "@/static/images/DeepSeek/copy.png";
import img_refresh from "@/static/images/DeepSeek/refresh.png";
import img_deepseek from "@/static/images/DeepSeek/deepseek.png";
import { message } from 'ant-design-vue';
import {
  SyncOutlined,
} from '@ant-design/icons-vue';

const props = defineProps(['deepseekParams', 'clearDeepSeekType'])
const loading = ref(false)
const deepseekParams = ref({})
const searchValue = ref('')
let content = [], num = 0
const list = ref([])
const userinfo = config.getUserInfo();

marked.use({
  async: true,
  pedantic: false,
  gfm: true,
});
/**
 * 折叠
 */
const changeThinkConten = (item, index) => {
  list.value[index].show = !item.show
}
/**
 * 修改 deepseek 返回的数据
 * @param choices 
 * @param text 
 * @param i 
 */
const rawText = async (choices, text, i) => {
  let html = await marked.parse(text)
  let vhtml = DOMPurify.sanitize(html);
  num++
  choices[i].message.contentHtml = vhtml
  list.value[list.value.length - 1].content = choices
  list.value[list.value.length - 1].eTime = Date.now()
  list.value[list.value.length - 1].loading = false
  loading.value = false
}
/**
 * 查询
 */
const searchDeepSeek = () => {
  // 验证用户是否用查询次数
  getDeepSeekCount(userinfo.userId).then(res => {
    if (res.status === 200 && res.data.code === 200) {
      return true

    } else {

      // 用户要求暂时去掉每日五条的要求
      // message.warn('每天每账户允许调用五次，您已到达上限，请明日再使用！')
      // return false
      return true
    }
  }).then((ele) => {
    if (ele) {
      loading.value = true

      num++
      list.value.push({ id: num, type: 'problem', content: searchValue.value })

      const params = deepseekParams.value
      content.push({ role: "user", content: searchValue.value })
      params.messages = content
      searchValue.value = ''
      num++
      list.value.push({ id: num, type: 'answer', content: [], time: 0, deep: params.model === 'deepseek-chat' ? false : true, sTime: Date.now(), eTime: Date.now(), loading: true, show: true })

      getDeepSeekApi(params).then((res) => {
        if (res.status === 200) {
          const json = res.data
          const { choices } = json
          content.push({ role: "assistant", content: choices[0].message.content })
          for (let i = 0; i < choices.length; i++) {
            rawText(choices, choices[i].message.content, i)
          }
          adddDeepSeekCount()
        }
      });
    }
  });

}
/**
 * 增加deepseek调用次数
 */
const adddDeepSeekCount = () => {
  setDeepSeekCount({ userId: userinfo.userId }).then(res => {
    // console.log(res, 565656)
  });
}
/**
 * 复制
 * @param text 
 */
const copyText = (text, e) => {
  handleCopy(text, e, () => {
    // console.log("这是复制成功回调函数")
    message.info("复制成功！")
  }, () => {
    // console.log("这是复制失败回调函数")
    message.info("复制失败！")
  })
}
/**
 * 刷新问题
 * @param text 
 * @param e 
 */
const refreshText = (i) => {
  searchValue.value = list.value[i - 1].content;
  searchDeepSeek()
}

watch(() => props.clearDeepSeekType, (val) => {
  list.value = []
  content = []
})
watch(() => props.deepseekParams, (val) => {
  deepseekParams.value = val
}, {
  immediate: true
})
</script>

<style lang='scss'>
.deepseek-result {
  background-color: #fff;
  min-height: 1rem;
  height: calc(100% - 4.5rem);
  width: 14.4rem;
  margin: .2rem auto 0;
  border-radius: .08rem;
  padding: .16rem 0;

  .scroll-list {
    height: calc(100% - 0.9rem);
    padding: 0 2rem;
    overflow-y: auto;

    li {

      .problem {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: .16rem;
        margin-bottom: .2rem;

        img {
          width: .28rem;
          height: .28rem;
        }

        span {
          display: inline-block;
          max-width: calc(100% - 1rem);
          background: #FBF5E6;
          border-radius: .12rem;
          font-size: .16rem;
          color: #262626;
          padding: .1rem .12rem;
        }
      }

      .answer {
        display: flex;
        flex-direction: row;
        gap: .16rem;

        >img {
          width: .32rem;
          height: .32rem;
        }

        .answer-content {
          display: flex;
          flex-direction: column;
          gap: .12rem;

          .no-think {
            border-radius: .12rem;
            font-size: .12rem;
            color: #262626;
            padding: .07rem .34rem;
            cursor: pointer;
            width: fit-content;
          }

          .think {
            background: url(~@/static/images/DeepSeek/thinking.png) no-repeat left center;
            background-size: .12rem;
            background-position: .14rem center;
            background-color: #F5F5F5;
            border-radius: .12rem;
            font-size: .12rem;
            color: #262626;
            padding: .07rem .34rem;
            cursor: pointer;
            width: fit-content;

            display: flex;
            align-items: center;

            &.down i {
              display: inline-block;
              width: .16rem;
              height: .16rem;
              background: url(~@/static/images/DeepSeek/down.png) no-repeat;
              background-size: .16rem;
              background-color: #F5F5F5;
            }

            &.up i {
              display: inline-block;
              width: .16rem;
              height: .16rem;
              background: url(~@/static/images/DeepSeek/up.png) no-repeat;
              background-size: .16rem;
              background-color: #F5F5F5;
            }
          }

          .think-conten {
            font-size: .14rem;
            color: #8B8B8B;
            border-left: .02rem solid #E5E5E5;
            padding-left: .12rem;
            line-height: .16rem;
          }

          .result-conten {
            color: #404040;
            display: flex;
            flex-direction: column;
            gap: .08rem;

            >p {
              font-size: .16rem;
              color: #404040;
              font-weight: bold;
              line-height: .28rem;

              strong {
                font-weight: bold;
                font-size: .18rem;
                color: #404040;
                line-height: 1.5;
              }
            }

            >hr {
              height: 1px;
              width: 100%;
              background: rgb(163, 163, 163);
              border: none;
              display: block;
            }

            h3 {
              // margin: .12rem 0;
              font-weight: bold;
              font-size: .18rem;
              color: #404040;

              strong {
                font-weight: bold;
                font-size: .18rem;
                color: #404040;
                line-height: 1.5;
              }
            }

            >ul,
            >ol {
              // margin: .14rem 0;
              padding-left: .28rem;

              li {
                margin: .04rem 0;
                font-size: .16rem;
                line-height: .2rem;

                strong {
                  font-weight: bold;
                  font-size: .16rem;
                }
              }
            }
          }

          .AI-warn {
            background: url(~@/static/images/DeepSeek/warn.png) no-repeat;
            background-size: .16rem .16rem;
            background-position: .13rem .1rem;
            background-color: #FDF8F5;
            border-radius: .12rem;
            border: 1px solid #F8EAE3;
            font-weight: 500;
            font-size: .14rem;
            color: #D37C4A;
            line-height: .16rem;
            padding: .1rem .12rem .1rem .36rem;
            width: fit-content;
          }

          .answer-btns {
            img {
              width: .28rem;
              height: .28rem;
              margin: 0 .02rem;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .input {
    position: relative;
    padding: 0 2rem;
    margin-top: .1rem;

    .send-btn {
      position: absolute;
      display: block;
      width: .32rem;
      height: .32rem;
      background: url(~@/static/images/DeepSeek/send-1.png) no-repeat;
      background-size: .32rem .32rem;
      right: 2.05rem;
      bottom: .05rem;
      cursor: pointer;

      &.no-message {
        background: url(~@/static/images/DeepSeek/send.png) no-repeat;
        background-size: .32rem .32rem;
        cursor: not-allowed;
      }
    }

    .loading {
      position: absolute;
      right: 2.05rem;
      bottom: .05rem;
      width: .32rem;
      height: .32rem;
      border-radius: .16rem;
      background-color: #34549a;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: not-allowed;

      i {
        display: inline-block;
        width: .1rem;
        height: .1rem;
        background-color: #fff;

      }
    }
  }

}
</style>